
function TipoYubicacion({ servicio, desdeDonde }) {
  
  const tipoServicio      = servicio?.tipoServicio || "NA"; // Digital, Presencial
  const tipoDesplaza      = servicio?.tipoDesplazamiento || servicio?.tipoDesplaza || "NA"; // Domicilio, EnLocal, Ambos
  const tipoDesplazaLabel = tipoDesplaza === "EnLocal" ? "En Local" : tipoDesplaza;
  const ubicacion         = servicio?.ubicacion || {};
  const ciudad            = servicio?.ciudad || "NA";
  const pais              = servicio?.pais || "NA";
  const zonasCobertura    = Array.isArray(servicio?.subzonas) ? servicio.subzonas : [];
  const esVistaGlobal     = desdeDonde === "Global";
  const mostrarDatosPrivadosUbicacion = !esVistaGlobal;
  const esUrgente         = !!servicio?.urgente;

  // Días de la semana disponibles: aplica a TODOS los paquetes, sean por Horas o por Días — el
  // selector "¿Qué días prestarás este servicio?" en paso4.jsx no está restringido a Horas (ver
  // servicio.js:59, "también afecta si escoge diasEntrega"). Unimos los días de todos los paquetes;
  // si cubren los 7 días (o no hay restricción configurada) no mostramos nada.
  const NOMBRES_DIAS_SEMANA = { 1: "Lun", 2: "Mar", 3: "Mié", 4: "Jue", 5: "Vie", 6: "Sáb", 7: "Dom" };
  const diasSemanaDisponibles = (() => {
    const paquetes = Array.isArray(servicio?.paquetes) ? servicio.paquetes : [];
    const set = new Set();
    paquetes.forEach((p) => {
      (Array.isArray(p?.diasSemana) ? p.diasSemana : []).forEach((d) => set.add(Number(d)));
    });
    return Array.from(set).sort((a, b) => a - b);
  })();
  const mostrarDiasSemana = diasSemanaDisponibles.length > 0 && diasSemanaDisponibles.length < 7;

  return (
    <div className="mt-4">
      <div className="card border-0" style={{ borderRadius: 18, border: "1px solid var(--color-border)", boxShadow: "0 10px 30px rgba(var(--azul-logo-fondo-rgb),0.06)", overflow: "hidden", }} >
        <div style={{ height: 5, background: "linear-gradient(90deg, var(--azul-logo-claro), var(--naranja-cta))", }} ></div>

        <div className="card-body p-4">
          {/* CONTENEDOR ICONO Y TITULO */}
          <div className="d-flex align-items-center gap-3 mb-3">
            <div className="d-flex justify-content-center align-items-center" style={{ width: 46, height: 46, borderRadius: 999, background: "rgba(var(--azul-logo-claro-rgb), 0.10)", color: "var(--azul-logo-claro)", flexShrink: 0, }} >
              <i className="bi bi-grid-1x2-fill" style={{ fontSize: 20 }}></i>
            </div>
            {/* TITULO */}
            <div>
              <h5 className="mb-0" style={{ color: "var(--color-text-primary)" }}> Tipo </h5>
              <small className="text-muted">Información general del servicio</small>
            </div>
          </div>


          {/* TIPO DE SERVICIO */}
          <div className="d-flex flex-wrap gap-2 mb-3">
            {/* TIPO DE SERVICIO */}
            <span className="fw-semibold" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 14px", borderRadius: 999, background: "rgba(var(--azul-logo-claro-rgb), 0.10)", color: "var(--color-text-primary)", border: "1px solid rgba(var(--azul-logo-claro-rgb), 0.12)", }} >
              <i className="bi bi-briefcase-fill" style={{ color: "var(--azul-logo-claro)" }}></i>
              {tipoServicio}
            </span>
            {/* TIPO DE PRESENCIALIDAD */}
            {tipoServicio === "Presencial" && tipoDesplaza !== "NA" ?
            <span className="fw-semibold" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 14px", borderRadius: 999, background: "rgba(var(--naranja-cta-rgb), 0.10)", color: "var(--color-text-primary)", border: "1px solid rgba(var(--naranja-cta-rgb), 0.18)", }} >
              <i className="bi bi-geo-alt-fill" style={{ color: "var(--naranja-cta)" }}></i>
              {tipoDesplazaLabel}
            </span>
            : null}

            {/* URGENTE */}
            {esUrgente ?
            <span className="fw-semibold" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 14px", borderRadius: 999, background: "rgba(var(--naranja-cta-rgb), 0.10)", color: "var(--color-text-primary)", border: "1px solid rgba(var(--naranja-cta-rgb), 0.18)", }} >
              <i className="bi bi-lightning-charge-fill" style={{ color: "var(--naranja-cta)" }}></i>
              Urgente
            </span>
            : null}
          </div>

          {/* NOTA URGENCIA */}
          {esUrgente ?
          <small className="d-block mb-2" style={{ color: "var(--color-text-secondary, #6c757d)" }}>
            <i className="bi bi-lightning-charge-fill me-1" style={{ color: "var(--naranja-cta)" }}></i>
            Este servicio admite reservas urgentes: puedes reservarlo con tan solo 2 horas de anticipación.
          </small>
          : null}

          {/* NOTA DÍAS DISPONIBLES */}
          {mostrarDiasSemana ?
          <small className="d-block mb-3" style={{ color: "var(--color-text-secondary, #6c757d)" }}>
            <i className="bi bi-calendar-week-fill me-1" style={{ color: "var(--azul-logo-claro)" }}></i>
            Días disponibles: {diasSemanaDisponibles.map((d) => NOMBRES_DIAS_SEMANA[d]).join(", ")}
          </small>
          : null}

          {/* PRESENCIAL: UBICACIÓN Y COBERTURA */}
          {tipoServicio === "Presencial" ? 
          <div className="mt-3" style={{ borderTop: "1px solid var(--color-border)", paddingTop: 18, }} >
            <div style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--color-border)", borderRadius: 16, padding: 16, }} > 
              {/* ICONO, TITULO */}
              <div className="d-flex align-items-center gap-2 mb-3">
                {/* ICONO */}
                <i
                  className={`bi ${tipoDesplaza === "Domicilio" ? "bi-pin-map-fill" : tipoDesplaza === "EnLocal" ? "bi-shop" : "bi-geo-alt"}`}
                  style={{ color: tipoDesplaza === "Domicilio" ? "var(--naranja-cta)" : "var(--azul-logo-claro)" }}
                ></i>
                <div>
                  {/* TITULO: COBERTURA O UBICACIÓN DE SERVICIO */}
                  <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                    {tipoDesplaza === "Domicilio" ? "Cobertura" : "Ubicación del servicio"}
                  </div>
                </div>
              </div>
              

              
              {/* DESCRIPCIÓN DE LA UBICACIÓN */}
              <div className="mb-3" style={{ background: "rgba(var(--azul-logo-claro-rgb), 0.08)", border: "1px solid rgba(var(--azul-logo-claro-rgb), 0.12)", borderRadius: 14, padding: 14, }} >
                <small style={{ color: "var(--color-text-primary)", lineHeight: 1.5, display: "block" }}>
                  {tipoDesplaza === "EnLocal"
                  ? "Debes visitar su ubicación para recibir el servicio. La dirección exacta se te compartirá después del pago."
                  : " Verifica que tu ubicación se encuentre dentro de las zonas de cobertura del servicio."
                  }
                </small>
              </div>
              
              {/* UBICACIÓN */}
              <div className="row g-3">
                {/* DIRECCIÓN: SOLO PARA USUARIO*/}
                {mostrarDatosPrivadosUbicacion && ubicacion?.direccionTexto ? 
                <div className="col-12 col-md-6">
                  <div style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)", borderRadius: 14, padding: 14, height: "100%", }} >
                    <small className="text-muted d-block mb-1">Dirección</small>
                    <div className="fw-semibold" style={{ color: "var(--color-text-primary)", lineHeight: 1.45 }}>
                      {ubicacion.direccionTexto}
                    </div>
                  </div>
                </div>
                : null}

                {/* REFERENCIA: SOLO PARA USUARIO */}
                {mostrarDatosPrivadosUbicacion && ubicacion?.referencia ? (
                  <div className="col-12 col-md-6">
                    <div style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)", borderRadius: 14, padding: 14, height: "100%", }} >
                      <small className="text-muted d-block mb-1">Referencia</small>
                      <div className="fw-semibold" style={{ color: "var(--color-text-primary)", lineHeight: 1.45 }}>
                        {ubicacion.referencia}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* CIUDAD Y PAÍS */}
                {(ciudad !== "NA" || pais !== "NA") ? (
                  <div className="col-12">
                    <div style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)", borderRadius: 14, padding: 14, }} >
                      <small className="text-muted d-block mb-1">Ciudad y país</small>
                      <div className="fw-semibold" style={{ color: "var(--color-text-primary)", lineHeight: 1.45 }}>
                        {[ciudad !== "NA" ? ciudad : null, pais !== "NA" ? pais : null].filter(Boolean).join(", ")}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* SUBZONAS */}
                {zonasCobertura.length > 0 ? (
                  <div className="col-12"> <div style={{ background: "var(--color-bg-surface)", border: "1px solid var(--color-border)", borderRadius: 14, padding: 14, }} >
                      <small className="text-muted d-block mb-1">Localidad</small>
                      <div className="fw-semibold" style={{ color: "var(--color-text-primary)", lineHeight: 1.45 }}>
                        {zonasCobertura.join(", ")}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              



              {/* BOTON UBICACIÓN: SOLO PARA USUARIO */}
              {tipoDesplaza !== "Domicilio" && !esVistaGlobal && ubicacion?.latitud && ubicacion?.longitud ? (
                <div className="mt-3 pt-3" style={{ borderTop: "1px solid var(--color-border)" }}>
                  <a
                    href={`https://www.google.com/maps?q=${ubicacion.latitud},${ubicacion.longitud}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none fw-semibold d-inline-flex align-items-center gap-2"
                    style={{ color: "var(--azul-logo-claro)" }}
                  >
                    <span className="d-inline-flex justify-content-center align-items-center" style={{ width: 34, height: 34, borderRadius: 999, background: "rgba(var(--azul-logo-claro-rgb), 0.10)", }} >
                      <i className="bi bi-geo-alt-fill"></i>
                    </span>
                    Ver ubicación
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          : null}

          {/* DIGITAL */}
          {tipoServicio === "Digital" ? (
            <div className="mt-3" style={{ borderTop: "1px solid var(--color-border)", paddingTop: 18 }}>
              <div style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--color-border)", borderRadius: 16, padding: 16 }}>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <i className="bi bi-laptop" style={{ color: "var(--azul-logo-claro)" }}></i>
                  <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                    Modalidad del servicio
                  </div>
                </div>

                <small style={{ color: "var(--color-text-primary)", lineHeight: 1.5 }}>
                  💻 Servicio 100% digital. No necesitas desplazarte. Todo el proceso se realiza online de forma rápida y segura.
                </small>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default TipoYubicacion;